/**
 * OIDC 로그아웃 관련 유틸리티 함수들
 * Spring Authorization Server 표준 OIDC RP-Initiated Logout 구현
 */ function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { getValidIdToken } from './token-validation-utils';
/**
 * OIDC 로그아웃 상태 키 (microblog-lms 호환)
 */ var LOGOUT_STATE_KEY = 'oidc_logout_state';
/**
 * 랜덤 state 생성 (OIDC 표준, microblog-lms 참조)
 */ var generateRandomState = function() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};
/**
 * 환경 변수에서 OIDC 로그아웃 파라미터 추출
 */ var getOidcLogoutParams = function(authConfig) {
    var _authConfig_api, _env_VITE_OAUTH2_REDIRECT_URI, _authConfig_oauth2, _authConfig_oauth21;
    var AUTH_SERVER_URL = (authConfig === null || authConfig === void 0 ? void 0 : (_authConfig_api = authConfig.api) === null || _authConfig_api === void 0 ? void 0 : _authConfig_api.authServerUrl) || import.meta.env.VITE_AUTH_SERVER_URL || 'https://auth.ugot.uk';
    var APP_URL = ((_env_VITE_OAUTH2_REDIRECT_URI = import.meta.env.VITE_OAUTH2_REDIRECT_URI) === null || _env_VITE_OAUTH2_REDIRECT_URI === void 0 ? void 0 : _env_VITE_OAUTH2_REDIRECT_URI.replace('/oauth2/redirect', '')) || 'https://app.ugot.uk';
    var clientId = (authConfig === null || authConfig === void 0 ? void 0 : (_authConfig_oauth2 = authConfig.oauth2) === null || _authConfig_oauth2 === void 0 ? void 0 : _authConfig_oauth2.clientId) || import.meta.env.VITE_OAUTH2_CLIENT_ID || 'app-client';
    var configuredLogoutUri = authConfig === null || authConfig === void 0 ? void 0 : (_authConfig_oauth21 = authConfig.oauth2) === null || _authConfig_oauth21 === void 0 ? void 0 : _authConfig_oauth21.logoutRedirectUri;
    var postLogoutRedirectUri = configuredLogoutUri || "".concat(APP_URL, "/landing?logout=true");
    return {
        authServerUrl: AUTH_SERVER_URL,
        clientId: clientId,
        postLogoutRedirectUri: postLogoutRedirectUri
    };
};
/**
 * OIDC 로그아웃 URL 생성.
 * authserver의 /connect/logout 필터는 client_id와 post_logout_redirect_uri만으로도
 * 서버 세션을 정리할 수 있으므로 id_token_hint가 없을 때도 로그아웃을 시도한다.
 * 
 * @returns 생성된 로그아웃 URL과 state 값
 */ export var createOidcLogoutUrl = function(authConfig, idTokenHint) {
    console.log('[AuthUtils] 🏗️ createOidcLogoutUrl 시작');
    // ID 토큰 검증
    console.log('[AuthUtils] 🔍 getValidIdToken 호출');
    var idToken = idTokenHint || getValidIdToken();
    console.log('[AuthUtils] 🔍 getValidIdToken 결과:', !!idToken);
    console.log('[AuthUtils] ⚙️ getOidcLogoutParams 호출');
    var params = getOidcLogoutParams(authConfig);
    console.log('[AuthUtils] ⚙️ 로그아웃 파라미터 생성 완료');
    // OIDC 표준 state 파라미터 생성 (microblog-lms 참조)
    console.log('[AuthUtils] 🎲 generateRandomState 호출');
    var state = generateRandomState();
    console.log('[AuthUtils] 🎲 state 생성 완료:', state);
    console.log('[AuthUtils] 📋 OIDC 로그아웃 파라미터 상세:');
    console.log('  🌐 authServerUrl:', params.authServerUrl);
    console.log('  🔑 clientId:', params.clientId);
    console.log('  🎫 id_token_hint:', idToken ? "".concat(idToken.substring(0, 30), "...") : 'null');
    console.log('  🔄 post_logout_redirect_uri:', params.postLogoutRedirectUri);
    console.log('  🎲 state:', state);
    // OIDC 로그아웃 URL 생성 (state 파라미터 포함)
    console.log('[AuthUtils] 🔨 로그아웃 URL 조립 중...');
    var logoutUrl = new URL("".concat(params.authServerUrl, "/connect/logout"));
    if (idToken) {
        logoutUrl.searchParams.set('id_token_hint', idToken);
    }
    logoutUrl.searchParams.set('post_logout_redirect_uri', params.postLogoutRedirectUri);
    logoutUrl.searchParams.set('client_id', params.clientId);
    logoutUrl.searchParams.set('state', state);
    console.log('[AuthUtils] ✅ OIDC 로그아웃 URL 생성 완료');
    console.log('[AuthUtils] 🌐 완성된 로그아웃 URL:', logoutUrl.toString());
    return {
        url: logoutUrl.toString(),
        state: state
    };
};
/**
 * OIDC 로그아웃 실행
 * 
 * @param navigate - 실패 시 사용할 navigate 함수
 * @param authConfig - 인증 설정
 */ export var performOidcLogout = function(navigate, authConfig, idTokenHint) {
    console.log('[AuthUtils] 🚀 performOidcLogout 시작');
    try {
        console.log('[AuthUtils] 🔗 createOidcLogoutUrl 호출 시작');
        var _createOidcLogoutUrl = createOidcLogoutUrl(authConfig, idTokenHint), logoutUrl = _createOidcLogoutUrl.url, state = _createOidcLogoutUrl.state;
        console.log('[AuthUtils] 🔗 createOidcLogoutUrl 호출 성공');
        console.log('[AuthUtils] 🌐 생성된 로그아웃 URL:', logoutUrl);
        console.log('[AuthUtils] 🔑 생성된 state:', state);
        // OIDC 표준 state 저장 (microblog-lms 참조)
        localStorage.setItem(LOGOUT_STATE_KEY, state);
        console.log('[AuthUtils] 💾 OIDC 로그아웃 state 저장 완료');
        // 현재 페이지 URL 확인
        console.log('[AuthUtils] 📍 현재 페이지 URL:', window.location.href);
        // 약간의 딜레이 후 리다이렉트 (상태 변경 완료 보장)
        console.log('[AuthUtils] ⏰ 100ms 딜레이 후 리다이렉트 예정');
        setTimeout(function() {
            console.log('[AuthUtils] 🚀 OIDC 로그아웃 리다이렉트 실행 시작');
            console.log('[AuthUtils] 🎯 리다이렉트 대상 URL:', logoutUrl);
            // 리다이렉트 실행
            window.location.href = logoutUrl;
            console.log('[AuthUtils] 🎯 window.location.href 설정 완료');
        // 참고: 이 로그 이후에는 페이지가 리다이렉트되므로 더 이상 로그가 보이지 않을 수 있음
        }, 100);
    } catch (error) {
        console.error('[AuthUtils] ❌ OIDC 로그아웃 실행 실패:', error);
        if (navigate) {
            // OIDC 실패 시 직접 랜딩 페이지로 이동
            var errorMessage = _instanceof(error, Error) ? error.message : 'oidc_failed';
            console.log('[AuthUtils] 🔄 에러 발생으로 navigate 함수로 이동:', "/landing?logout=true&error=".concat(encodeURIComponent(errorMessage)));
            navigate("/landing?logout=true&error=".concat(encodeURIComponent(errorMessage)));
        } else {
            console.log('[AuthUtils] ⚠️ navigate 함수가 없어 에러를 다시 던짐');
            throw error; // navigate가 없으면 에러를 다시 던짐
        }
    }
};
/**
 * OIDC 로그아웃 state 검증 (미래 확장용)
 * 
 * @param receivedState - 서버에서 받은 state 값
 * @returns state가 유효한지 여부
 */ export var validateLogoutState = function(receivedState) {
    var storedState = localStorage.getItem(LOGOUT_STATE_KEY);
    var isValid = storedState === receivedState;
    if (isValid) {
        console.log('[AuthUtils] OIDC 로그아웃 state 검증 성공');
        localStorage.removeItem(LOGOUT_STATE_KEY);
    } else {
        console.warn('[AuthUtils] OIDC 로그아웃 state 검증 실패:', {
            storedState: storedState,
            receivedState: receivedState
        });
    }
    return isValid;
};
